export type ImageFormat = "webp" | "jpeg" | "png";

/** App-only image proxy — avoids Coolify/nginx serving /uploads/ as static files. */
export const IMAGE_PROXY_PREFIX = "/i/";

function uploadFilename(src: string): string | null {
  const path = src.split("?")[0];
  if (!path.startsWith("/uploads/")) return null;
  return path.slice("/uploads/".length);
}

/** Build a resized image URL (handled by server.ts + sharp). */
export function optimizedUploadUrl(src: string, width: number, format: ImageFormat = "webp"): string {
  const filename = uploadFilename(src);
  if (!filename) return src;
  const params = new URLSearchParams();
  params.set("w", String(width));
  params.set("f", format);
  return `${IMAGE_PROXY_PREFIX}${filename}?${params}`;
}

export function buildUploadSrcSet(
  src: string,
  widths: number[],
  format: ImageFormat = "webp",
): string {
  return widths.map((w) => `${optimizedUploadUrl(src, w, format)} ${w}w`).join(", ");
}

export function defaultUploadSrc(
  src: string,
  widths: number[],
  format: ImageFormat = "webp",
): string {
  const sorted = [...widths].sort((a, b) => a - b);
  const largest = sorted[sorted.length - 1] ?? sorted[0];
  return largest ? optimizedUploadUrl(src, largest, format) : src;
}
